import React from 'react';
import NoData from 'components/_common/NoData';
import PageUtil from 'utils/Page.util';
import Loading from 'components/_common/Loading';
import ChartBar from 'components/_common/chart/Chart.bar';
import ChartPie from 'components/_common/chart/Chart.pie';
import ChartHorizontalBar from 'components/_common/chart/Chart.horizontal.bar';

const AsAnalyticsV = ({
    params,
    setParams,
    handleChange
}) => {
    const {
        isLoaded,
        error,
        monthlyRevenueData,      // 월별 AS수익 (수평 막대)
        yearlyAsData,            // 연도별 AS현황 (파이차트)
        categoryAsData,          // 중류별 AS현황 (파이차트)  
        regionAsData,            // 지역별 AS현황 (수직 막대)
        asRevenueTableData,      // AS 수입 지출 테이블
        selectedYear,
        selectedMonth,
    } = params;

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>AS현황 분석({selectedYear}년{selectedMonth ? ` ${selectedMonth}월` : ''})</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* 년도 선택 필터 */}
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <div className="as-analytics-year-selector">
                                    <div className="form-group">
                                        <label>분석 년도</label>
                                        <select
                                            className="form-control"
                                            value={selectedYear}
                                            onChange={(e) => handleChange(e, 'selectedYear', e.target.value)}
                                        >
                                            <option value="2026">2026년</option>
                                            <option value="2025">2025년</option>
                                            <option value="2024">2024년</option>
                                            <option value="2023">2023년</option>
                                            <option value="2022">2022년</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>분석 월</label>
                                    <select
                                        className="form-control"
                                        value={selectedMonth || ''}
                                        onChange={(e) => handleChange(e, 'selectedMonth', e.target.value)}
                                    >
                                        <option value="">전체</option>
                                        <option value="1">1월</option>
                                        <option value="2">2월</option>
                                        <option value="3">3월</option>
                                        <option value="4">4월</option>
                                        <option value="5">5월</option>
                                        <option value="6">6월</option>
                                        <option value="7">7월</option>
                                        <option value="8">8월</option>
                                        <option value="9">9월</option>
                                        <option value="10">10월</option>
                                        <option value="11">11월</option>
                                        <option value="12">12월</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* 메인 차트 영역 - 검은 배경으로 통일 */}
                        <div className="card" style={{ backgroundColor: '#2c3e50', padding: '20px', marginBottom: '20px' }}>
                            <div className="row">
                                {/* 1. 월별/일별 AS수익 (상단 좌측, 수평 막대차트) */}
                                <div className="col-md-6">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px', marginBottom: '15px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>
                                            {selectedMonth ? `${selectedMonth}월 일별 AS수익` : '월별 AS수익'}
                                        </h4>
                                        <small style={{ color: '#bdc3c7' }}>단위 : 만원</small>
                                        <div style={{ height: '250px', marginTop: '10px' }}>
                                            {monthlyRevenueData && monthlyRevenueData.length > 0 ? (
                                                <ChartHorizontalBar
                                                    data={monthlyRevenueData}
                                                    indexBy="month"
                                                    keys={["revenue"]}
                                                    xLabel=""
                                                    yLabel=""
                                                    colors={['rgba(52, 152, 219, 1)']}
                                                    valueFormat={(value) => `${value}만원`}
                                                    labelFormat={(key) => ''}
                                                />
                                            ) : (
                                                <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                    데이터 로딩 중...
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* 2. 지역별 AS현황 (상단 우측, 수직 막대차트) */}
                                <div className="col-md-6">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px', marginBottom: '15px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>지역별 AS현황</h4>
                                        <small style={{ color: '#bdc3c7' }}>단위 : 건</small>
                                        <div style={{ height: '250px', marginTop: '10px' }}>
                                            {regionAsData && regionAsData.length > 0 ? (
                                                <ChartBar
                                                    data={regionAsData}
                                                    indexBy="region"
                                                    keys={["count"]}
                                                    xLabel=""
                                                    yLabel=""
                                                    colors={['rgba(52, 152, 219, 1)']}
                                                    valueFormat={(value) => `${value}건`}
                                                    labelFormat={(key) => ''}
                                                />
                                            ) : (
                                                <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                    데이터 로딩 중...
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                {/* 3. 제조년월별 AS현황 (하단 좌측, 파이차트) */}
                                <div className="col-md-6">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>
                                            {`제조년월별 AS현황 ${(selectedMonth ? selectedYear + '년 ' + selectedMonth + '월' : selectedYear + '년 ')}`}
                                        </h4>
                                        <div className="row">
                                            {/* 파이차트 */}
                                            <div className="col-md-7">
                                                <div style={{ height: '250px' }}>
                                                    {yearlyAsData && yearlyAsData.length > 0 ? (
                                                        <ChartPie
                                                            data={yearlyAsData}
                                                            labelKey="year"
                                                            keys={["count"]}
                                                            colors={[
                                                                'rgba(231, 76, 60, 1)',
                                                                'rgba(241, 196, 15, 1)',
                                                                'rgba(46, 204, 113, 1)',
                                                                'rgba(52, 152, 219, 1)',
                                                                'rgba(155, 89, 182, 1)',
                                                                'rgba(230, 126, 34, 1)'
                                                            ]}
                                                            valueFormat={(value) => `${value}건`}
                                                            labelFormat={(label) => label}
                                                        />
                                                    ) : (
                                                        <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                            {selectedMonth
                                                                ? `${selectedYear}년 ${selectedMonth}월에 표시가 없으면 총갯수가 없습니다`
                                                                : `${selectedYear}년에 표시가 없으면 총갯수가 없습니다`
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 통계 정보 박스 - 제조년월별 */}
                                            <div className="col-md-5">
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    height: '250px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    border: '2px solid #e74c3c'
                                                }}>
                                                    {yearlyAsData && yearlyAsData.length > 0 ? (
                                                        <>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#e74c3c',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    총 수리 건수
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.yearlyDetailStats.totalCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px', paddingLeft: '10px' }}>
                                                                <span style={{
                                                                    fontSize: '13px',
                                                                    color: '#95a5a6',
                                                                    fontWeight: 'normal'
                                                                }}>
                                                                    ㄴ 일반
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '13px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'normal',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.yearlyDetailStats.normalCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px', paddingLeft: '10px' }}>
                                                                <span style={{
                                                                    fontSize: '13px',
                                                                    color: '#95a5a6',
                                                                    fontWeight: 'normal'
                                                                }}>
                                                                    ㄴ 대용량
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '13px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'normal',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.yearlyDetailStats.largeCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#e74c3c',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    무상수리
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.yearlyDetailStats.freeRepairCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#e74c3c',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    수익
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {(params.yearlyDetailStats.totalRevenue / 10000).toLocaleString()}만원
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#e74c3c',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    지출
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {(params.yearlyDetailStats.totalCost / 10000).toLocaleString()}만원
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#e74c3c',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    출장
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.yearlyDetailStats.tripCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div style={{ textAlign: 'center', color: '#7f8c8d' }}>
                                                            데이터가 없습니다
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* 4. 종류별 AS현황 (하단 우측, 파이차트) */}
                                <div className="col-md-6">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>
                                            {`종류별 AS현황 ${(selectedMonth ? selectedYear + '년 ' + selectedMonth + '월' : selectedYear + '년 ')}`}
                                        </h4>
                                        <div className="row">
                                            {/* 파이차트 */}
                                            <div className="col-md-7">
                                                <div style={{ height: '250px' }}>
                                                    {params.productTypeGraphData && params.productTypeGraphData.length > 0 ? (
                                                        <ChartPie
                                                            data={params.productTypeGraphData}
                                                            labelKey="productType"
                                                            keys={["count"]}
                                                            colors={[
                                                                'rgba(231, 76, 60, 1)',   // F - 빨강
                                                                'rgba(241, 196, 15, 1)',  // OB - 노랑
                                                                'rgba(46, 204, 113, 1)',  // YB - 초록
                                                                'rgba(149, 165, 166, 1)', // 대용량 - 회색
                                                                'rgba(155, 89, 182, 1)'   // 기타 - 보라 (추가!)
                                                            ]}
                                                            valueFormat={(value) => `${value}건`}
                                                            labelFormat={(label) => label}
                                                        />
                                                    ) : (
                                                        <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                            {selectedMonth
                                                                ? `${selectedYear}년 ${selectedMonth}월에 표시가 없으면 총갯수가 없습니다`
                                                                : `${selectedYear}년에 표시가 없으면 총갯수가 없습니다`
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 통계 정보 박스 - 종류별 (기존 코드 유지) */}
                                            <div className="col-md-5">
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    height: '250px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    border: '2px solid #f39c12'
                                                }}>
                                                    {params.productTypeGraphData && params.productTypeGraphData.length > 0 ? (
                                                        <>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#f39c12',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    총 수리 건수
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.productTypeDetailStats.totalCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#f39c12',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    무상수리
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.productTypeDetailStats.freeRepairCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#f39c12',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    수익
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {(params.productTypeDetailStats.totalRevenue / 10000).toLocaleString()}만원
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '6px' }}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#f39c12',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    지출
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {(params.productTypeDetailStats.totalCost / 10000).toLocaleString()}만원
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#f39c12',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    출장
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    color: '#2c3e50',
                                                                    fontWeight: 'bold',
                                                                    marginLeft: '5px'
                                                                }}>
                                                                    {params.productTypeDetailStats.tripCount.toLocaleString()}건
                                                                </span>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div style={{ textAlign: 'center', color: '#7f8c8d' }}>
                                                            데이터가 없습니다
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 기존 5번 차트 위치를 3개로 분할 */}
                            <div className="row mt-3">
                                {/* 견적금액 (막대차트) */}
                                <div className="col-md-4">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>
                                            {selectedYear}년 {selectedMonth ? `${selectedMonth}월 일별 ` : '월별 '}견적금액
                                        </h4>
                                        <small style={{ color: '#bdc3c7' }}>단위 : 만원</small>
                                        <div style={{ height: '250px', marginTop: '10px' }}>
                                            {params.revenueDetailData && params.revenueDetailData.length > 0 ? (
                                                <ChartBar
                                                    data={params.revenueDetailData}
                                                    indexBy="month"
                                                    keys={["estimate"]}
                                                    xLabel=""
                                                    yLabel=""
                                                    colors={['rgba(52, 152, 219, 1)']} // 파랑
                                                    valueFormat={(value) => `${value}만원`}
                                                    labelFormat={(key) => '견적금액'}
                                                />
                                            ) : (
                                                <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                    데이터 로딩 중...
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* 출장비 (막대차트) */}
                                <div className="col-md-4">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>
                                            {selectedYear}년 {selectedMonth ? `${selectedMonth}월 일별 ` : '월별 '}출장비
                                        </h4>
                                        <small style={{ color: '#bdc3c7' }}>단위 : 만원</small>
                                        <div style={{ height: '250px', marginTop: '10px' }}>
                                            {params.revenueDetailData && params.revenueDetailData.length > 0 ? (
                                                <ChartBar
                                                    data={params.revenueDetailData}
                                                    indexBy="month"
                                                    keys={["tripFee"]}
                                                    xLabel=""
                                                    yLabel=""
                                                    colors={['rgba(241, 196, 15, 1)']} // 노랑
                                                    valueFormat={(value) => `${value}만원`}
                                                    labelFormat={(key) => '출장비'}
                                                />
                                            ) : (
                                                <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                    데이터 로딩 중...
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* 수리원가 (막대차트) */}
                                <div className="col-md-4">
                                    <div style={{ backgroundColor: '#34495e', padding: '15px', borderRadius: '8px' }}>
                                        <h4 style={{ color: 'white', marginBottom: '15px' }}>
                                            {selectedYear}년 {selectedMonth ? `${selectedMonth}월 일별 ` : '월별 '}수리원가
                                        </h4>
                                        <small style={{ color: '#bdc3c7' }}>단위 : 만원</small>
                                        <div style={{ height: '250px', marginTop: '10px' }}>
                                            {params.revenueDetailData && params.revenueDetailData.length > 0 ? (
                                                <ChartBar
                                                    data={params.revenueDetailData}
                                                    indexBy="month"
                                                    keys={["repairCost"]}
                                                    xLabel=""
                                                    yLabel=""
                                                    colors={['rgba(231, 76, 60, 1)']} // 빨강
                                                    valueFormat={(value) => `${value}만원`}
                                                    labelFormat={(key) => '수리원가'}
                                                />
                                            ) : (
                                                <div style={{ color: 'white', textAlign: 'center', paddingTop: '100px' }}>
                                                    데이터 로딩 중...
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 3개 테이블을 가로로 배치 - 개별 스크롤 */}
                        <div className="row">
                            {/* 일반보일러 상세 현황 */}
                            <div className="col-md-4 col-sm-4">
                                {params.productTypeData && params.productTypeData.length > 0 && (
                                    <div className="card card-outline card-info" style={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
                                        <div className="card-header">
                                            <div className="card-title">일반보일러 상세 현황 - 전체 {params.productTypeData.length}개</div>
                                            <div className="card-tools">
                                                <span className="badge bg-info">
                                                    {params.productTypeData.reduce((sum, item) => sum + item.count, 0)} 총건
                                                </span>
                                            </div>
                                        </div>
                                        <div className="card-body p-0" style={{ flex: 1, overflow: 'auto' }}>
                                            <table className="table text-nowrap table-striped mb-0">
                                                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                                    <tr>
                                                        <th style={{ width: '50px' }}>순위</th>
                                                        <th>제품명</th>
                                                        <th style={{ width: '80px' }}>건수</th>
                                                        <th style={{ width: '80px' }}>비율</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {params.productTypeData.map((item, index) => {
                                                        const totalCount = params.productTypeData.reduce((sum, p) => sum + p.count, 0);
                                                        const percentage = ((item.count / totalCount) * 100).toFixed(1);
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span className={`badge ${index < 3 ? 'bg-primary' : 'bg-secondary'}`}>
                                                                        {index + 1}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <strong>{item.productType}</strong>
                                                                </td>
                                                                <td>
                                                                    <span className="badge bg-success">{item.count}건</span>
                                                                </td>
                                                                <td>
                                                                    <small className="text-muted">{percentage}%</small>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* 대용량보일러 상세 현황 */}
                            <div className="col-md-4 col-sm-4">
                                {params.largeBoilerData && params.largeBoilerData.length > 0 && (
                                    <div className="card card-outline card-warning" style={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
                                        <div className="card-header">
                                            <div className="card-title">대용량보일러 상세 현황 - 전체 {params.largeBoilerData.length}개</div>
                                            <div className="card-tools">
                                                <span className="badge bg-warning">
                                                    {params.largeBoilerData.reduce((sum, item) => sum + item.count, 0)} 총건
                                                </span>
                                            </div>
                                        </div>
                                        <div className="card-body p-0" style={{ flex: 1, overflow: 'auto' }}>
                                            <table className="table text-nowrap table-striped mb-0">
                                                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                                    <tr>
                                                        <th style={{ width: '50px' }}>순위</th>
                                                        <th>제품명</th>
                                                        <th style={{ width: '80px' }}>건수</th>
                                                        <th style={{ width: '80px' }}>비율</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {params.largeBoilerData.map((item, index) => {
                                                        const totalCount = params.largeBoilerData.reduce((sum, p) => sum + p.count, 0);
                                                        const percentage = ((item.count / totalCount) * 100).toFixed(1);
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span className={`badge ${index < 3 ? 'bg-warning' : 'bg-secondary'}`}>
                                                                        {index + 1}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <strong>{item.capacity}</strong>
                                                                </td>
                                                                <td>
                                                                    <span className="badge bg-info">{item.count}건</span>
                                                                </td>
                                                                <td>
                                                                    <small className="text-muted">{percentage}%</small>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ✅ 부품별 상세 현황을 2개의 테이블로 분리 */}
                            <div className="col-md-4 col-sm-4">
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', height: '600px' }}>
                                    {/* 일반부품 테이블 */}
                                    <div className="card card-outline card-success" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                                        <div className="card-header" style={{ flexShrink: 0 }}>
                                            <div className="card-title">일반부품 상세 현황</div>
                                            <div className="card-tools">
                                                <span className="badge bg-success">
                                                    {params.normalPartData?.reduce((sum, item) => sum + item.count, 0) || 0} 총건
                                                </span>
                                            </div>
                                        </div>
                                        <div className="card-body p-0" style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                                            {params.normalPartData && params.normalPartData.length > 0 ? (
                                                <table className="table text-nowrap table-striped mb-0">
                                                    <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                                        <tr>
                                                            <th style={{ width: '40px' }}>순위</th>
                                                            <th>부품명</th>
                                                            <th style={{ width: '60px' }}>건수</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {params.normalPartData.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span className={`badge ${index < 3 ? 'bg-success' : 'bg-secondary'}`}>
                                                                        {index + 1}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <strong style={{ fontSize: '12px' }}>{item.partName}</strong>
                                                                </td>
                                                                <td>
                                                                    <span className="badge bg-info">{item.count}건</span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div className="text-center p-3 text-muted">데이터가 없습니다</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* 대용량부품 테이블 */}
                                    <div className="card card-outline card-warning" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                                        <div className="card-header" style={{ flexShrink: 0 }}>
                                            <div className="card-title">대용량부품 상세 현황</div>
                                            <div className="card-tools">
                                                <span className="badge bg-warning">
                                                    {params.heavyPartData?.reduce((sum, item) => sum + item.count, 0) || 0} 총건
                                                </span>
                                            </div>
                                        </div>
                                        <div className="card-body p-0" style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                                            {params.heavyPartData && params.heavyPartData.length > 0 ? (
                                                <table className="table text-nowrap table-striped mb-0">
                                                    <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                                        <tr>
                                                            <th style={{ width: '40px' }}>순위</th>
                                                            <th>부품명</th>
                                                            <th style={{ width: '60px' }}>건수</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {params.heavyPartData.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span className={`badge ${index < 3 ? 'bg-warning' : 'bg-secondary'}`}>
                                                                        {index + 1}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <strong style={{ fontSize: '12px' }}>{item.partName}</strong>
                                                                </td>
                                                                <td>
                                                                    <span className="badge bg-info">{item.count}건</span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div className="text-center p-3 text-muted">데이터가 없습니다</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default AsAnalyticsV;